<template>
  <div style="padding:10px" v-show="info.orderId">
    <back />
    <div class="status whiteBg">
      <div class="font-18">
        {{ set_status(this.info) }}
      </div>
      <div
        class="address"
        v-if="info.orderStatus === 0 && info.payStatus === 0"
      >
        <div class="font-14">{{ info.siteInfo.siteName }}</div>
        <div class="font-12 deInfo">
          <div>
            详细地址：{{
              info.senderProvince +
                info.senderCity +
                info.senderDistrict +
                info.siteInfo.siteAddress
            }}
          </div>
          <div>
            营业时间：{{
              `${info.siteInfo.siteOpenTime}~${info.siteInfo.siteCloseTime}`
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="listInfo whiteBg">
      <div class="detail">
        <div>
          <div style="font-weight:700">{{ info.senderName }}</div>
          <div class="province">{{ info.senderCity }}</div>
        </div>
        <div>
          <img src="@/../static/icon-arrow-success.svg" alt="" />
        </div>
        <div>
          <div style="font-weight:700">{{ info.receiverName }}</div>
          <div class="province">{{ info.receiverCity }}</div>
        </div>
      </div>
      <div class="list-item font-13 bbm flex">
        <div class="left">快递公司</div>
        <div>{{ info.expressCompanyName }}</div>
      </div>
      <div class="list-item font-13 bbm flex" v-if="info.expressCode">
        <div class="left">快递单号</div>
        <div>
          {{ info.expressCode }}
          <span style="color:#a30015" @click="copyText(info.expressCode)"
            >&nbsp;复制</span
          >
        </div>
      </div>
      <div class="list-item font-13 bbm flex" v-if="info.realAmount">
        <div class="left">支付金额</div>
        <div>￥{{ formatMoney(info.realAmount) }}</div>
      </div>
      <div class="list-item font-13 bbm flex">
        <div class="left">物品类型</div>
        <div>{{ info.goodsName }}</div>
      </div>
      <div class="list-item font-13 bbm flex">
        <div class="left">寄件地址</div>
        <div class="info">
          <div>{{ info.senderName + ' ' + info.senderPhone }}</div>
          <div class="address-detail">
            {{
              info.senderProvince +
                info.senderCity +
                info.senderDistrict +
                info.senderAddress
            }}
          </div>
        </div>
      </div>
      <div class="list-item font-13 bbm flex">
        <div class="left">收件地址</div>
        <div class="info">
          <div>{{ info.receiverName + ' ' + info.receiverPhone }}</div>
          <div class="address-detail">
            {{
              info.receiverProvince +
                info.receiverCity +
                info.receiverDistrict +
                info.receiverAddress
            }}
          </div>
        </div>
      </div>
      <div class="list-item font-13 bbm flex">
        <div class="left">订单号</div>
        <div>
          {{ info.orderId }}
          <span style="color:#a30015" @click="copyText(info.orderId)"
            >&nbsp;复制</span
          >
        </div>
      </div>
      <div class="list-item font-13 bbm flex">
        <div class="left">下单时间</div>
        <div>{{ formatTime(info.createTime) }}</div>
      </div>
      <div class="list-item font-13 bbm flex" v-if="info.note">
        <div class="left">备注</div>
        <div>{{ info.note }}</div>
      </div>
      <div class="list-item font-13 bbm flex" v-if="info.cancelReason">
        <div class="left">取消原因</div>
        <div>{{ info.cancelReason }}</div>
      </div>
    </div>
    <div class="end">
      <div class="infoBottom whiteBg">
        <van-button
          plain
          round
          color="#000"
          class="btn"
          @click.stop="goFastMail()"
          >再寄一单</van-button
        >
        <van-button
          plain
          round
          color="#000"
          class="btn"
          v-if="
            (info.orderStatus == 0 || info.orderStatus == 1) &&
              info.payStatus != 2
          "
          @click.stop="handleCancel()"
          >取消寄件</van-button
        >
        <van-button
          plain
          round
          color="#000"
          class="btn"
          v-if="info.orderStatus == 2 || info.orderStatus == -1"
          @click.stop="handleDelete()"
          >删除</van-button
        >
        <!-- <van-button
          plain
          round
          color="#a30014"
          class="btn"
          v-if="info.payStatus == 1"
          @click.stop="handlePay()"
          >支付订单</van-button
        > -->
      </div>
    </div>
    <cancel-order ref="cancel" :orderInfo="info" @refresh="onRefresh" />
  </div>
</template>
<script>
import { Dialog } from 'vant'
import cancelOrder from '../Home/components/cancelOrder'
import Back from '@/components/back'
export default {
  data() {
    return {
      params: null,
      info: {}
    }
  },
  components: {
    cancelOrder,
    Back
  },
  created() {
    if (this.$route.query !== '{}') {
      //   console.log(this.$route.query)
      this.params = this.$route.query
      this.getDetail()
    }
  },
  methods: {
    onRefresh() {
      this.getDetail()
    },
    copyText(value) {
      let input = document.createElement('input')
      input.value = value
      input.setAttribute('readonly', 'readonly')
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      this.$toast({
        position: 'bottom',
        message: '复制成功'
      })
      document.body.removeChild(input)
    },
    getDetail() {
      this.$api.getUserOrderDetail(this.params).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.info = res.data
        }
      })
    },
    handleCancel() {
      this.$refs.cancel.handleShow()
    },
    handleDelete() {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该订单？'
      })
        .then(() => {
          // on confirm
          let params = {
            orderId: this.info.orderId
          }
          this.$api.deleteOrder(params).then(res => {
            if (res.code === 0) {
              this.$notify({
                message: '删除成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  // this.$router.options.routes[1].meta.keepAlive = false
                  this.$router.replace('/home')
                }
              })
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    set_status(item) {
      let msg = ''
      if (item.orderStatus === -1) {
        msg = '已取消'
      }
      if (item.orderStatus === 0 && item.payStatus === 0) {
        msg = '待投递'
      }
      if (item.orderStatus === 0 && item.payStatus === 1) {
        msg = '待支付'
      }
      if (item.orderStatus === 0 && item.payStatus === 2) {
        msg = '已支付'
      }
      if (item.orderStatus === 1 && item.payStatus === 2) {
        msg = '已支付'
      }
      if (item.orderStatus === 2) {
        msg = '已完成'
      }
      return msg
    },
    formatTime(value) {
      return this.$format(value)
    },
    formatMoney(value) {
      let result = parseFloat(value)
      if (isNaN(result)) {
        return false
      }
      result = Math.floor(value * 100) / 100
      let str = result.toString()
      let index = str.indexOf('.')
      if (index < 0) {
        index = str.length
        str += '.'
      }
      while (str.length <= index + 2) {
        str += '0'
      }
      return str
    },
    goFastMail() {
      this.$store.commit('clearInfo')
      this.$router.replace({ path: '/goFastMail' })
    },
    handlePay() {
      this.$router.push({ name: 'pay', query: { orderId: this.info.orderId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.status {
  width: calc(100% - 20px);
  padding: 15px 10px 10px;
  border-radius: 3px;
  .address {
    background-color: #f4f4f4;
    margin-top: 10px;
    padding: 10px;
    .deInfo {
      margin-top: 5px;
      color: #555;
    }
  }
}
.listInfo {
  margin-top: 10px;
  margin-bottom: 50px;
  border-radius: 3px;
  .detail {
    display: flex;
    justify-content: space-around;
    padding: 0 10%;
    border-bottom: 1px solid #f2f2f2;
    > div {
      // flex-wrap: wrap;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 30%;
      height: 70px;
      // line-height: 70px;
      text-align: center;
      .province {
        font-size: 14px;
        color: #7f7f7f;
      }
    }
  }
  .list-item {
    padding: 10px;
    .left {
      width: 60px;
      margin-right: 20px;
    }
    :nth-child(2) {
      flex: 1;
    }
    .address-detail {
      word-break: break-all;
    }
  }
}
.infoBottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 50px;
  .btn {
    margin: 0 5px;
    width: 90px;
    height: 36px;
  }
}
.end {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  //   height: 100px;
  background-color: #fff;
}
</style>
